import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './index.scss';
import NsLinkModal from '../../../../components/tm/NsLinkModal';
import TookiTakiTable from '../../dashboard/TookiTakiTable/index';
import CustomerProfileTable from '../../dashboard/TookiTakiTable/CustomerProfileTable';
import { C2CTableHeader } from '../../../../components/TableHeader/index';
import Wait4Me from '../../../../components/Wait4Me/index';
import NoDataToDisplay from '../../../../components/NoDataToDisplay/index';
import C2AWidget from '../../dashboard/C2AWidget/index';
import { parseColumnsForC2A } from '../investigationDetailSettingsUtil';

import { isEmpty } from '../../../../util/lodashlike';
/**
 * TransactionRow single
 * @param txt
 * @returns {*}
 * @constructor
 */
const TransactionRow = ({ txt }) => {
  return (
    <div
      className="row"
      style={{
        textAlign: 'center',
        padding: 10,
        margin: 0,
        backgroundColor: 'white'
      }}>
      <div className="col-md-12">
        <p style={{ textAlign: 'center' }}>{txt}</p>
      </div>
    </div>
  );
};

/**
 * CustomerProfile component
 */
class CustomerProfile extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { selectedCustomer } = prevState;
    const { customers, onCustomerChanged } = nextProps;

    if (!selectedCustomer && Array.isArray(customers) && customers.length > 0) {
      onCustomerChanged(customers[0]);

      return {
        ...prevState,
        selectedCustomer: customers[0]
      };
    }
    return null;
  }

  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    this.state = {
      additionalInfoPeriod: '3M',
      tooltip: {
        vOpen: false
      },
      nsLinkModal: {
        isShown: false,
        data: []
      },
      jointOwnerInfo: {
        isShown: false,
        data: {}
      },
      selectedCustomer: null,
      currentPage: 0,
      isTableExpanded: false
    };
  }

  onScrollToLoad = () => {
    const { currentPage } = this.state;
    this.setState({ currentPage: currentPage + 1 });
    this.props.onScrollToLoad((currentPage + 1) * 20);
  };

  changeAdditionalInfoPeriod = (value) => {
    this.setState({
      additionalInfoPeriod: value
    });
  };

  fetchRiskIndicator = (riskIndicator) => {
    if (this.props.fetchRiskIndicator) {
      this.props.fetchRiskIndicator(riskIndicator);
    }
  };

  isTookiTableExpanded = (isExpanded) => {
    this.setState({ isTableExpanded: isExpanded });
  };

  toggleJointOwnerModal = () => {
    this.setState({
      jointOwnerInfo: {
        isShown: !this.state.jointOwnerInfo.isShown,
        data: {}
      }
    });
  };

  toggleNSLinkModal = () => {
    this.setState({
      nsLinkModal: {
        isShown: !this.state.nsLinkModal.isShown,
        data: []
      }
    });
  };

  toggleVTooltip = () => {
    this.setState({
      tooltip: {
        ...this.state.tooltip,
        vOpen: !this.state.tooltip.vOpen
      }
    });
  };

  render() {
    const { nsLinkModal, isTableExpanded } = this.state;
    const {
      customerProfile,
      linkedCustomersResp,
      associatedAccountsCheckingSavingsSettings,
      associatedAccountsCreditCards,
      associatedAccountsLoan,
      associatedAccountsFixedDeposit,
      isCustomerProfileAllowed,
      isAssociatedCustomersAllowed,
      isAssociatedAccountsAllowed
    } = this.props;

    const { data, hasMore, isFetching } = linkedCustomersResp || {};
    const { linked_c2c_accounts = [] } = data || {};
    let isC2CLoading = false;
    if (isEmpty(customerProfile)) {
      isC2CLoading = true;
    }
    const assocAccounts = customerProfile?.associated_accounts
      ? customerProfile.associated_accounts
      : [];
    const assocAccountObject = {
      FD: [],
      CREDIT: [],
      LOAN: [],
      SAVING: []
    };

    assocAccounts.map((account) => {
      if (account.product === 'FIXED DEPOSITS') {
        assocAccountObject['FD'].push(account);
      } else if (account.product === 'CREDIT CARDS') {
        assocAccountObject['CREDIT'].push(account);
      } else if (account.product === 'LOANS') {
        assocAccountObject['LOAN'].push(account);
      } else if (account.product === 'SAVINGS') {
        assocAccountObject['SAVING'].push(account);
      }
      return assocAccountObject;
    });

    //table content
    let paginatedRowOption = [];
    if (linked_c2c_accounts && linked_c2c_accounts.length > 0) {
      if (hasMore) {
        if (!isFetching) {
          paginatedRowOption.push(
            <div
              className="row"
              style={{
                textAlign: 'center',
                padding: 10,
                margin: 0,
                backgroundColor: 'white',
                cursor: 'pointer'
              }}>
              <div className="col-md-12">
                <a onClick={this.onScrollToLoad} className={style.loadMore}>
                  Load More
                </a>
              </div>
            </div>
          );
        } else {
          paginatedRowOption.push(<TransactionRow txt={'Loading...'} />);
        }
      }
    } else if (isFetching) {
      paginatedRowOption.push(
        <div
          className="row"
          style={{
            textAlign: 'center',
            padding: 10,
            margin: 0,
            backgroundColor: 'white'
          }}>
          <div className="col-md-12">
            <Wait4Me />
          </div>
        </div>
      );
    } else {
      paginatedRowOption.push(<NoDataToDisplay />);
    }

    const c2aColumnsMap = {
      SAVINGS_HEADER_SETTINGS: parseColumnsForC2A(
        associatedAccountsCheckingSavingsSettings
      ),
      CREDIT_HEADER_SETTINGS: parseColumnsForC2A(associatedAccountsCreditCards),
      LOAN_HEADER_SETTINGS: parseColumnsForC2A(associatedAccountsLoan),
      FIXED_DEPOSIT_HEADER_SETTINGS: parseColumnsForC2A(
        associatedAccountsFixedDeposit
      )
    };

    return (
      <div className={style.profileWrapper}>
        <div className={style.customer}>
          {isCustomerProfileAllowed ? (
            <CustomerProfileTable customerProfile={customerProfile} />
          ) : null}
          {isAssociatedCustomersAllowed && (
            <div className={style.customBlock}>
              <div className={classnames(style.customerRiskBody, 'clearfix')}>
                <TookiTakiTable
                  title={'Associated customers'}
                  header={C2CTableHeader}
                  isExpanded={this.isTookiTableExpanded}
                  data={linked_c2c_accounts}
                />
                {isTableExpanded && paginatedRowOption}
              </div>
            </div>
          )}

          {isAssociatedAccountsAllowed && (
            <div className={style.customBlock}>
              <div className={classnames(style.customerRiskBody, 'clearfix')}>
                <C2AWidget
                  c2aColumnsMap={c2aColumnsMap}
                  isC2CLoading={isC2CLoading}
                  c2aData={assocAccountObject}
                />
              </div>
            </div>
          )}
        </div>
        <NsLinkModal
          nsLinkModal={nsLinkModal}
          toggleModal={this.toggleNSLinkModal}
        />
        {/* <JointOwnerInfo jointOwnerInfo={jointOwnerInfo} toggleModal={this.toggleJointOwnerModal} /> */}
      </div>
    );
  }
}

/**
 * proptypes
 * @type {{customerProfile: shim, linkedCustomersResp: shim}}
 */
CustomerProfile.propTypes = {
  customerProfile: PropTypes.object.isRequired,
  linkedCustomersResp: PropTypes.object.isRequired,
  isCustomerProfileAllowed: PropTypes.bool,
  isAssociatedCustomersAllowed: PropTypes.bool,
  isAssociatedAccountsAllowed: PropTypes.bool
};

export default CustomerProfile;
